import * as actionTypes from "./actionTypes";
import api from "../../services";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import { deleteFileFromS3, uploadFileToS3 } from "./physicianOnboardingActions";
import constants from "../../constants";
import { getUserData, updateUserData } from "../../utils/localStorage";
import messages from "../../constants/messages";
import { addPatientChatAttachment } from "./doctorPatientsActions";

export const setOngoingAppointmentData = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_ONGOINGAPPOINTMENT_DATA,
      payload,
    });
  };
};

export const setChatData = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_CHAT,
      payload,
    });
  };
};

export const clearChat = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.CLEAR_CHAT,
    });
  };
};

export const onMessageNotification = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.CHAT_NOTIFICATION_MESSAGE,
      payload,
    });
  };
};

export const setPhysicians = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_PHYSICIANS,
      payload,
    });
  };
};

export const removeOngoingAppointmentData = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_ONGOINGAPPOINTMENT_DATA,
    });
  };
};

export const removeParticipants = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_PARTICIPANTS,
    });
  };
};

export const setSharedFiles = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_SHARED_FILES,
      payload,
    });
  };
};

export const setSharedDocuments = (file, cb = () => {}) => {
  return dispatch => {
    const sharedDoc = uploadFileToS3(file[0]);

    sharedDoc
      .then(sharedDocData => {
        dispatch(addPatientChatAttachment(sharedDocData?.location));
        cb(sharedDocData?.location);
      })
      .catch(err => {
        console.log(err);
        catchHandler("Shared Document upload failed");
      });
  };
};

export const removeSharedDocuments = file => {
  return dispatch => {
    dispatch(
      deleteFileFromS3(
        {
          src: file,
        },
        () => {}
      )
    );

    dispatch({
      type: actionTypes.REMOVE_SHARED_DOCUMENTS,
      payload: file,
    });
  };
};

export const searchPhysicians = (
  patientId,
  name = "",
  speciality,
  is_available,
  page = 1
) => {
  return (dispatch, getState) => {
    const physicians = getState()?.dashboard?.ongoingAppointment?.physicians;

    const payload = {
      patient_detail_id: patientId,
      request_sorting_field: "first_name_asc",
      is_available: is_available,
      speciality: speciality ? [speciality?.value] : constants.SPECIALITIES,
      user_latitude: 0,
      user_longitude: 0,
      filter_distance: 0,
    };

    dispatch(apiStart(true));
    api
      .searchPhysicians(name, page, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];
          const data =
            page > 1 ? [...physicians, ...resp.results] : resp.results;

          dispatch(
            setPhysicians({
              results: data,
              total_pages: resp.links.total_pages,
            })
          );
        } else if (res.status_code === 404) {
          dispatch({
            setAppointmentData: [],
          });
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("error:", error);
        catchHandler(error, dispatch);
      });
  };
};

export const addParticipant = (physicianId, cb = () => {}) => {
  return (dispatch, getState) => {
    const appointmentType =
      getState()?.dashboard?.ongoingAppointment?.appointmentType;

    if (appointmentType === "visit_now_appointment") {
      const visitNowData = getState()?.dashboard?.ongoingAppointment?.visitNow;

      const payload = {
        guest_doctor: physicianId,
        guest_doctor_status: "REQUESTED",
        patient: visitNowData?.patient?.id,
        doctor: getUserData()?.id,
        topic: visitNowData?.topic,
        is_request_from_appointment: false,
      };

      dispatch(apiStart());
      api
        .updateVisitNowRequest(visitNowData?.id, payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            dispatch(
              setOngoingAppointmentData({
                visitNow: res.data,
              })
            );
            successHandler(messages.VISIT_NOW_REQUEST_SENT);
            cb();
          } else {
            errorHandler(res.message[0]);
          }

          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else {
      const appointmentData =
        getState()?.dashboard?.appointments?.schAppointmentDetail;

      const payload = {
        topic: appointmentData?.topic,
        doctor: getUserData()?.id,
        patient: appointmentData?.patient_detail?.id,
        doctor_status: "ACCEPTED",
        guest_doctor: physicianId,
        guest_doctor_status: "REQUESTED",
        is_request_from_appointment: true,
        appointment: appointmentData?.id,
      };

      dispatch(apiStart());
      api
        .addVisitNowRequest(payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            dispatch(
              setOngoingAppointmentData({
                visitNow: res.data,
              })
            );
            successHandler(messages.VISIT_NOW_REQUEST_SENT);
            cb();
          } else {
            errorHandler(res.message[0]);
          }

          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    }
  };
};

export const updateGuestDoctorRequest = (appointmentId, status, cb) => {
  return (dispatch, getState) => {
    const payload = {
      guest_doctor_status: status,
    };

    dispatch(apiStart());
    (status === "CANCEL_INVITE"
      ? api.removeGuestDoctorRequest(appointmentId)
      : api.updateGuestDoctorRequest(appointmentId, payload)
    )
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          let message = "";

          switch (status) {
            case constants.APPOINTMENT_STATUS.accepted:
              message = messages.INVITE_ACCEPTED_SUCCESS;
              break;
            case constants.APPOINTMENT_STATUS.requested:
              message = messages.INVITE_SENT_SUCCESS;
              break;
            case constants.APPOINTMENT_STATUS.cancelled:
              message = messages.INVITE_CANCEL_SUCCESS;
              break;
            case constants.APPOINTMENT_STATUS.denied:
              message = messages.INVITE_DENIED_SUCCESS;
              break;
            default:
              message = messages.INVITE_UPDATED_SUCCESS;
          }

          successHandler(message);
          cb();
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const addGuestDoctor = (physicianId, flowType = "scheduled", cb) => {
  return (dispatch, getState) => {
    const appointments = getState()?.dashboard?.appointments;

    const appointmentData =
      (flowType === "appointment_detail" && appointments?.appointmentDetail) ||
      (flowType === "scheduled" && appointments?.schAppointmentDetail);

    const payload = {
      guest_doctor_status: "REQUESTED",
      guest_doctor: physicianId,
    };

    dispatch(apiStart());
    api
      .addGuestDoctor(appointmentData?.id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler(messages.INVITE_SENT_SUCCESS);
          cb();
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getPatientVitals = () => {
  return (dispatch, getState) => {
    const payload = {
      patient:
        getState()?.dashboard?.ongoingAppointment?.currentAppointment
          ?.patient_detail?.id ||
        getState()?.dashboard?.ongoingAppointment?.currentAppointment?.patient
          ?.id,
    };

    dispatch(apiStart());
    api
      .getPatientVitals(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            setOngoingAppointmentData({
              vitals: res.data[0],
            })
          );
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getChatDetail = (chatId, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    api
      .getChatDetails(chatId)
      .then(response => {
        const res = response.data;
        if (res?.status_code === 200) {
          dispatch(
            setChatData({
              after_call_chat: res?.data[0],
            })
          );
          cb();
          updateUserData({
            chat_notify: {
              is_chat_listen: false,
            },
          });
        } else {
          // errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateChatDetail = (chatId, payload, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    const message_payload = {
      message: [payload],
    };

    api
      .updateChatDetail(chatId, message_payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb();
          updateUserData({
            chat_notify: {
              is_chat_listen: false,
            },
          });
        } else {
          // errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};
